import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  PRODUTOS: 'Carregando Produtos',
  POSICOES: 'Carregando posições do estoque',
}

const INITIAL_STATE = {
  selectedEstoque: null,
  periodo: getPeriodoMesAtual(),
  posicoes: [],
  estoques: [],
  showSomenteComInventario: false,
  globalFilter: '',
  qtePosicoesInventariadas: 0,
  qtePosicoesNaoInventariadas: 0,
  percentualPosInventariadas: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useRelatorioInventarioPosicao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      getPosicoesEstoqueRelatorioInventario(selectedTp, estoqueId, pInicial, pFinal) {
        EstoqueHttp.getPosicoesEstoquesRelatorioInventario(selectedTp, estoqueId, pInicial, pFinal)
          .then(res => {
            const posInventariadasSeqs = [
              ...new Set(res.filter(p => p.status === 'Finalizado').map(p => p.sequencia)),
            ]

            const qtePosInventaridas = posInventariadasSeqs.length
            const qtePosNaoInventaridasComInventarioEmAberto = [
              ...new Set(
                res
                  .filter(
                    p => p.status !== 'Finalizado' && !posInventariadasSeqs.includes(p.sequencia),
                  )
                  .map(p => p.sequencia),
              ),
            ]
            const qtePosNaoInventariadasSemInventario = [
              ...new Set(
                res
                  .filter(p => !p.status && !posInventariadasSeqs.includes(p.sequencia))
                  .map(p => p.sequencia),
              ),
            ]
            const totalDePosicoes = [...new Set(res.map(p => p.sequencia))].length

            setState(prevState => ({
              ...prevState,
              posicoes: res,
              qtePosicoesInventariadas: qtePosInventaridas,
              qtePosicoesNaoInventariadas: [
                ...new Set([
                  ...qtePosNaoInventaridasComInventarioEmAberto,
                  ...qtePosNaoInventariadasSemInventario,
                ]),
              ].length,
              percentualPosInventariadas: `${((100 / totalDePosicoes) * qtePosInventaridas).toFixed(2)}%`,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Events
      onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          EstoqueHttp.getEstoques(selectedTp)
            .then(res =>
              setState(prevState => ({
                ...prevState,
                estoques: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          if (name === 'showSomenteComInventario' && value)
            prevState['showSomenteSemInventario'] = false
          else if (name === 'showSomenteSemInventario' && value)
            prevState['showSomenteComInventario'] = false
          return { ...prevState }
        })
      },

      onSearchRelatorioPosicoes(pInicial, pFinal, selectedEstoque) {
        setState(prevState => {
          if (!selectedEstoque) prevState.errorMessage = 'Selecione um estoque.'
          else {
            prevState.periodo = { pInicial, pFinal }
            prevState.loadingMessage = LOAD_MESSAGE.POSICOES
          }
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
